import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import { useEffect } from "react";
import { Col, Row } from "react-grid-system";
import KioskProduct from "./KioskProduct";
import useKioskCategory from "./useKioskCategory";

const KioskCategory = ({ categoryId, id }: { id: any; categoryId: string }) => {
  const [, setDeliveryMethod] = usePosOrderDeliveryMethod();

  const { data } = useKioskCategory(id, categoryId);

  useEffect(() => {
    const dId: any = id;
    setDeliveryMethod(dId);
  }, [id]);
  return (
    <>
      {data && (
        <>
          <div className="h-full">
            <Row>
              {data?.sub_content?.map((product) => (
                <Col
                  style={{ marginBottom: "2rem" }}
                  md={6}
                  lg={4}
                  key={product.item_id}
                >
                  <KioskProduct
                    parentId={parseInt(categoryId)}
                    // @ts-ignore
                    product={product}
                  />
                </Col>
              ))}
            </Row>
          </div>
        </>
      )}
    </>
  );
};

export default KioskCategory;
